import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface ReportFilter {
  date_start?: string;
  date_end?: string;
  vendor_start?: string;
  vendor_end?: string;
  product_start?: string;
  product_end?: string;
  dept_start?: string;
  dept_end?: string;
}

export interface DetailItem {
  vendor_code: string;
  vendor_name: string;
  prod_code: string;
  color_code: string;
  prod_name: string;
  unit: string;
  qty: number;
  unit_price: number;
  amount: number;
}

export interface VendorUnitSummary {
  vendor_code: string;
  vendor_name: string;
  unit: string;
  total_qty: number;
  avg_price: number;
  total_amt: number;
}

export interface UnitGrandTotal {
  unit: string;
  total_qty: number;
  total_amt: number;
}

export interface ReportData {
  details: DetailItem[];
  vendor_summary: VendorUnitSummary[];
  grand_totals: UnitGrandTotal[];
  total_doc_count: number;
  total_item_count: number;
}

export interface ReportResponse {
  data?: ReportData;
  message?: string;
}

// ============================================================
// API Client
// ============================================================

export const d318Api = {
  async query(filter: ReportFilter): Promise<ReportResponse> {
    // Remove empty string params to keep URL clean
    const params: Record<string, string> = {};
    for (const [k, v] of Object.entries(filter)) {
      if (v && v.trim() !== '') {
        params[k] = v.trim();
      }
    }
    const res = await apiClient.get('/api/d318/report', { params });
    return res.data;
  },
};
